import { styled } from '@mui/material/styles';
import { PageHeader } from '@qpr/components';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import ConnectionsIcon from '../../../assets/ConnectionsIcon';
import Layout from '../components/CanvasLayoutComponent';
import { CanvasLayoutElement, getData, getTitle, isInited } from './canvas-layout-view-model';
const PREFIX = 'view';

const classes = {
  pageHeader: `${PREFIX}-pageHeader`
};

export interface CanvasLayoutProps {
  containerId: string;
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.pageHeader}`]: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
    color: 'white',
    flexBasis: '30px',
    overflow: 'visible'
  }
}));

export interface CanvasLayoutProps {
  containerId: string;
}

const view = ({ containerId }: CanvasLayoutProps) => {
  const [data, setData] = useState<CanvasLayoutElement[]>([]);
  const [title, setTitle] = useState<string>('Processing data...');

  const attributes = new URLSearchParams(useLocation().search).get('attributes') || undefined;

  useEffect(() => {
    const initView = async () => {
      setData(await getData(containerId, attributes));

      if (!isInited()) setTitle('No data found');
      else setTitle(getTitle() || 'Canvas layout');
    };
    initView();
  }, [containerId]);

  return (
    <Root>
      <div className={classes.pageHeader}>
        <PageHeader title={title} icon={<ConnectionsIcon fontSize="inherit" />} />
      </div>
      <Layout data={data} />
    </Root>
  );
};

export default view;
